// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:639px){.service-services-block__list .service-card__name br{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
